import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, OnDestroy } from '@angular/core';
import {  Router } from '@angular/router';
import {
    OrderGuideDto,
    WebshopSendBasketOutput,
    WebShopServiceProxy,
    BasketArticleDto, ProcessorTargetDto
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

import { appModuleAnimation } from '@axilla/axilla-shared';
import * as _ from 'lodash-es';
import {take, repeat, filter, delay, takeUntil, finalize} from 'rxjs/operators';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';

import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
import { BaseModalComponent } from '@app/shared/common/modals/base-modal/base-modal.component';
import { BaseModalOption, BaseModalButton } from '@app/shared/common/modals/base-modal/models';
import { AxillaPackage, BasketArticleExtendedDto } from '@app/shared/common/shop-system/models/models';
import { OrderService } from '../shared/services/order.service';
import { Subject } from 'rxjs';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';
import {OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';

@Component({
    templateUrl: './basket-overview.component.html',
    styleUrls: ['./basket-overview.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class BasketOverviewComponent extends AppComponentBase implements OnInit, OnDestroy {

    set orderGuide(value: OrderGuideDto) {
        this._orderGuide = value;
    }
    get orderGuide() {
        return this._orderGuide;
    }

    get saving(): boolean {
        return this._webshopService.saving;
    }

    get isCheckOrderState(): boolean {
        return this.orderStateService.isCheckOrderState;
    }

    get isAllowGoBackToPromotion(): boolean {
        return this.orderStateService.isVerifyPromotionState;
    }
    get isAllowGoBackToProducts(): boolean {
        return this.orderStateService.isCheckOrderState;
    }

    constructor(
        injector: Injector,
        private _router: Router,
        private webShopServiceProxy: WebShopServiceProxy,
        private orderService: OrderService,
        private fieldAgentOrderService: FieldAgentOrderService,
        private orderStateService: OrderStateService,
        private _fieldAgentOrderService: FieldAgentOrderService,

        private _webshopService: WebshopService
    ) {
        super(injector);

    }

    get isBackorderAvailable(): boolean {
        return this._webshopService.isBackorderAvailable;
    }
    get package(): AxillaPackage {
        if (!this._package) {
            this._package = this._webshopService.package;
        }

        return this._package;
    }
    set package(value: AxillaPackage) {
        this._package = value;
    }

    get packagePallets() {
        return _.reverse(this.package.pallets);
    }

    //#endregion Package


    //#region isBlocked

    get isBlocked(): boolean {
        return this._webshopService.isOuBlocked;
    }

    get isDisabled(): boolean {
        if (this.saving) {
            return true;
        }

        return !(this.basket && this.basket.length > 0);
    }


    //#region Minimum amount
    get isAmountFitMinimumAmountRequirements(): boolean {
        return this._webshopService.checkMinimumAmountRequirements();
    }

    get isConfirmDisabled(): boolean {
        if (this.isBlocked) {
            return true;
        }

        if (this.permissionChecker.isGranted(BasePermissionDefinition.Webshop.View.HasMOV)) {
            return this.isDisabled || this.isAmountFitMinimumAmountRequirements;
        }

        return this.isDisabled;
    }

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;
    @ViewChild('appBaseModal', { static: true }) modal: BaseModalComponent;

    private _orderGuide: OrderGuideDto;

    isLoading = false;

    updateBasketSubscription$;


    //#region Package
    private _package: AxillaPackage;

    packageUpdatetSubscription$;

    //#region Order Availability

    unsubscribe: Subject<any> = new Subject<any>();

    private _onBasketUpdate() {
        this.updateBasketSubscription$ = this._webshopService.basketUpdate$
            .subscribe((items: BasketArticleDto[]) => {
                this.setDataTable();
            });
    }

    ngOnInit(): void {
        if (!this.basket || this.basket.length === 0) {
            this._webshopService.initBasket();
        }

        this._onBasketUpdate();
        this._onPackageUpdate();

        if (this.isOuBlocked) {
            this.showIsBlockedMessage();
        } else {
            this.checkIsOuBlocked();
        }
    }

    ngOnDestroy(): void {
        this.updateBasketSubscription$.unsubscribe();
        this.packageUpdatetSubscription$.unsubscribe();

        this.unsubscribe.next(true);
    }

    private _onPackageUpdate() {
        this.packageUpdatetSubscription$ = this._webshopService.packageUpdate$
            .subscribe((axillaPackage: AxillaPackage) => {
                this.package = axillaPackage;
            });
    }

    //#endregion isBlocked

    getBasket(event?: any) {
        this.setDataTable();
    }

    setDataTable() {
        if (this.basket || this.basket.length >= 0) {
            this.primengTableHelper.records = this.basket;
            this.primengTableHelper.totalRecordsCount = this.basket.length;
        }
    }

    clearOrder() {
        this._webshopService.clear();

        if (this.isGuided && this.isAllowGoBackToPromotion)  {
            this.backToPromotion();
        }
    }

    onSelectTargetRole(targetRole: string, ...restParams: any[]): void {
        this.isLoading = true;
        this._webshopService.confirm(targetRole).subscribe((result: WebshopSendBasketOutput) => {
            this.makePostRedirect(result);
            this.isLoading = false;
        }, error => {
            this.isLoading = false;
        });
    }

    onCancelSelectTargetRole() {
        if (this.isGuided) {
            this.orderStateService.checkCart();
        }
    }

    test(targetRole: string): void {
        alert(targetRole);
    }

    getSession() {
        if (abp.session.userId > 0) {
            return true;
        }
        return false;
    }

    login(): void {
        abp.event.trigger('app.show.loginModal');
        //this._router.navigate([AppRouteGuard.loginUrl]);
    }

    checkOrderAvailability(input: any): void {
        try {
            this.isLoading = true;

            if (this.isGuided) {
                const sendObject = JSON.parse(input.sendObject);
                this.fieldAgentOrderService.setOrderScheduleId(sendObject.OrderScheduleId);
                this.fieldAgentOrderService.setOrderTotalAmount(sendObject.OrderTotal);
            }

            const vdbName = 'App.Webshop.OrderCreation';
            const orderId = input.url.split('/app/webshop/order-details/')[1];
            try {
                this.orderService.getDataFromVdb$(orderId, vdbName)
                    .pipe(
                        delay(2000),
                        repeat(),
                        filter((data: any, index) => this.retry(data, index)),
                        take(1),
                        takeUntil(this.unsubscribe)
                    )
                    .subscribe((result: any) => {
                        try {
                            this.isLoading = false;
                            abp.event.trigger('app.show.loadingBarHide');

                            if (this.isGuided) {
                                this.orderStateService.selectPromotion();
                            }

                            this.makePostRedirect(input);
                        } catch (e) {
                            console.log('makePostRedirect error');
                        }
                    });
            } catch (e) {
                console.log('getDataFromVdb error');
            }
        } catch (e) {
            console.log(e, 'checkOrderAvailability error');
        }

    }

    retry(data: any, index): boolean {
        if (data && data.items) {
            const item = data.items[0];
            if (item == null || item.value == null) {
                return false;
            }
            let value = item.value;

            return value.Created;
        }

        return false;
    }

    //#endregion Order Availability

    confirmOrder() {
        this.isLoading = true;
        if (this.getSession()) {

            if (this.orderStateService.isVerifyPromotionState) {
                this.spinnerService.show();

                //TODO: possible issue with promotion basket
                this._webshopService
                    .confirm('FieldAgentPromotion')
                    .pipe(
                        finalize(()=> {
                            this.isLoading = false;
                            this.spinnerService.hide();
                        })
                    )
                    .subscribe({
                        next: (result: WebshopSendBasketOutput) => {
                            this._webshopService.clear(true);
                            this.notify.success('Order created');
                            this.spinnerService.hide();
                            this._router.navigate(['app/webshop/field-agent/order-confirmation']);
                            this.orderStateService.confirmOrder();
                        },
                        error: error => {
                            this.isLoading = false;
                            this.spinnerService.hide();
                        }
                    });
            } else {
                if (this.isGuided) {
                    this.orderStateService.selectSupplier();
                }

                this.webShopServiceProxy.getTargetRolesForUser()
                    .subscribe((result: ProcessorTargetDto[]) => {

                        //let isPunchout = _.filter(result, item => {
                        //    return item == 'Punchout'
                        //});


                        //let isWebshop = _.filter(result, item => {
                        //    return item == 'Webshop'
                        //});


                        let isDirect = _.filter(result, item => {
                            return item === 'DirectWebshop';
                        });
                        //redirect to confirm order directly if we have directwebshop target
                        if (isDirect.length > 0) {
                            this._webshopService.getShipmentArticles$().pipe(
                                take(1)
                            ).subscribe((result) => {
                                this._router.navigate(['app/webshop/confirm-order']);
                            });
                        } else {
                            if (result.length > 1) {
                                //this.modal.show(
                                //    "You have two possible ways of confirming the order. Which one would you like to use?",
                                //    result);

                                let buttons: BaseModalButton[] = _.map(result, (item: ProcessorTargetDto) => {
                                    let button: BaseModalButton = {
                                        cssClass: 'btn-primary',
                                        title: item.roleName,
                                        params: [item.roleName],
                                        targetRole: item.roleName,
                                        redirect: undefined,
                                        isRedirectAction: false,
                                        idSelector: _.camelCase(item.roleName)
                                    };

                                    if (item.roleName === 'DirectWebshop') {
                                        button.isRedirectAction = true;
                                        button.redirect = 'app/webshop/confirm-order';
                                    } else {
                                        button.action = (targetRole: string) => {
                                            this.isLoading = true;

                                            //trigger
                                            abp.event.trigger('app.show.loadingBarShow');
                                            this.informAboutOrderLoading();

                                            if (this.isGuided) {
                                                this.fieldAgentOrderService.setTarget(targetRole);
                                            }

                                            this._webshopService
                                                .confirm(targetRole)
                                                .subscribe((result: WebshopSendBasketOutput) => {
                                                    this.checkOrderAvailability(result);
                                                }, error => {
                                                    this.isLoading = false;
                                                    abp.event.trigger('app.show.loadingBarHide');

                                                });
                                        };
                                    }
                                    return button;
                                });

                                let modalOption: BaseModalOption;
                                if (this.isGuided) {
                                    modalOption = {
                                        title: 'Select supplier',
                                        buttons: buttons,
                                        modalCssClass: 'modal-xs',
                                        verticalBtn: true
                                    };
                                } else {
                                    modalOption = {
                                        text: 'You have multiple possible ways of confirming the order. Which one would you like to use?',
                                        buttons: buttons,
                                        modalCssClass: 'modal-lg',
                                        verticalBtn: false
                                    };
                                }
                                this.modal.showUpdated(modalOption);

                                this.isLoading = false;

                            } else if (result.length === 1) {
                                this.informAboutOrderLoading();

                                let targetRole = result[0].roleName;
                                this._webshopService
                                    .confirm(targetRole)
                                    .subscribe((result: WebshopSendBasketOutput) => {
                                        this.checkOrderAvailability(result);
                                    }, error => {
                                        this.isLoading = false;
                                    });
                            } else {
                                this.isLoading = false;
                            }
                        }
                    });
            }


        } else {
            this.login();
        }
    }

    informAboutOrderLoading() {
        let message = this.localization.localize('Axilla.App.Webshop.App.BasketConfirm.Message', 'AxillaAppWebshop');
        abp.message.info(message, undefined);

    }
    makePostRedirect(result: WebshopSendBasketOutput) {

        this.spinnerService.show();

        let obj = result.sendObject;
        let url = result.url;
        let contentType = result.contentType;

        //url start with http - its external request
        //if its not started with http its internal request
        if (url.indexOf('http') > -1) {
            let mapForm = document.createElement('form');
            mapForm.target = '_self';
            mapForm.method = result.action;
            mapForm.action = url;


            if (mapForm.method.toUpperCase() === 'POST') {
                mapForm.contentType = contentType;
                if (typeof (obj) === 'object') {
                    Object.keys(obj).forEach(function(param) {
                        let mapInput = document.createElement('input');
                        mapInput.type = 'hidden';
                        mapInput.name = param;
                        mapInput.setAttribute('value', obj[param]);
                        mapForm.appendChild(mapInput);
                    });
                } else if (typeof (obj) === 'string') {
                    let mapInput = document.createElement('input');
                    mapInput.type = 'hidden';
                    mapInput.name = 'cxml-urlencoded';
                    mapInput.setAttribute('value', obj);
                    mapForm.appendChild(mapInput);
                }
            }


            let mapSubmit = document.createElement('input');
            mapSubmit.setAttribute('type', 'submit');
            mapSubmit.setAttribute('value', 'submit');
            mapSubmit.setAttribute('style', 'display: none;');
            mapSubmit.id = 'zycus-submit';

            mapForm.appendChild(mapSubmit);
            document.getElementById('pa-form').appendChild(mapForm);
        } else {
            this._router.navigate([url]);
        }

        this._webshopService.clear(true);
        this.notify.success('Order created');
        this.spinnerService.hide();

        //this.modal.show("Do you want to send order to Zycus?",
        //    'Send Data To Zycus');

        //this._redirect.post(objResult.sendObject, objResult.url, objResult.contentType);
    }
    submitForm() {
        document.getElementById('zycus-submit').click();
    }
    cancelEverything() {

    }
    remove(item: BasketArticleDto) {
        if (item) {
            this._webshopService.remove(item);
        }
    }
    //#endregion Minimum amount


    changeAmountInBasket(article: BasketArticleExtendedDto) {
        this._changeAmountInBasket(article);
    }

    private _changeAmountInBasket(article: BasketArticleExtendedDto) {
            if (+article.quantity <= 0) {
                this.notify.info('Item quantity = 0, change ');
                return;
            }

            const item = _.cloneDeep(article);
            this._webshopService.changeItem(item);
    }

    confirmChangingItemCount(article: BasketArticleExtendedDto) {
        this.changeAmountInBasket(article);

        //abp.message.confirm("The item count is changed.","Do you want to save the changes?",(isConfirmed)=> {
        //    if (isConfirmed) {
        //        this.changeAmountInBasket(article);
        //    } else {
        //        var count = this._webshopService.getCountById(article.id);
        //        article.quantity = count;
        //    }
        //});
    }

    getArticleQuantity(article: BasketArticleDto): number {
        return article.availableAmount;
    }

    backToPromotion() {
        this._router.navigate([`/app/webshop/field-agent/promotion`]);
        this.orderStateService.selectPromotion();
    }

    backToProducts() {
        this._router.navigate([`/app/webshop/articles/${this._fieldAgentOrderService.selectedBrandValue.id}`]);
        this.orderStateService.selectProducts();
    }

    isPromotionLimitExceeded(): boolean {
        const result = this.totalItemAmount / this.promotionValueInEuro;

        return result < 1.02 && result > 1.00;
    }

    get orderAmount(): number {
        return +this._fieldAgentOrderService.orderTotalAmountValue;
    }

    get promotionValue(): number {
        return this._fieldAgentOrderService.selectedOrderGuideTemplate.reduction;
    }

    get promotionValueInEuro(): number {
        if (this.promotionValue > 0) {
            return this.orderAmount * (this.promotionValue / 100);
        }

        return 0;
    }

    get totalItemAmount(): number {
        return this._webshopService.totalItemAmount;
    }

    get isVerifyPromotions(): boolean {
        return this.orderStateService.isVerifyPromotionState;
    }
}
